import { gql } from "@apollo/client";

export const GET_BRANCHES = gql`
  query GetBranches {
    getBranches {
      id
      address
      name
      phone
      is_main
    }
  }
`;

export const GET_PARTNER = gql`
  query GetPartner {
    getPartner {
      id
      logo
      about
      short_desc
      fb_page
      instagram
      webpage
      url_name
    }
  }
`;

export const GET_SHIPPING_COSTS = gql`
  query GetShippingCosts {
    getShippingCosts {
      id
      price
      distance
      status
    }
  }
`;

export const ADD_SHIPPING_COST = gql`
  mutation AddShippingCost($data: ShippingCostInput!) {
    addShippingCost(data: $data) {
      id
      price
      distance
      status
    }
  }
`;

export const UPDATE_SHIPPING_COST = gql`
  mutation UpdateShippingCost($data: ShippingCostInput!) {
    updateShippingCost(data: $data) {
      id
      price
      distance
      status
    }
  }
`;

export const DELETE_SHIPPING_COST = gql`
  mutation DeleteShippingCost($id: ID!) {
    deleteShippingCost(id: $id)
  }
`;

export const GET_TABLES = gql`
  query GetTables($branch: Int) {
    getTables(branch: $branch) {
      id
      name
      branch_id
    }
  }
`;

export const ADD_TABLE = gql`
  mutation AddTable($name: String!, $branch_id: Int!) {
    addTable(name: $name, branch_id: $branch_id) {
      id
      name
      branch_id
    }
  }
`;

export const UPDATE_TABLE = gql`
  mutation UpdateTable($id: Int!, $name: String!) {
    updateTable(id: $id, name: $name) {
      id
      name
      branch_id
    }
  }
`;

export const DELETE_TABLE = gql`
  mutation DeleteTable($id: Int!) {
    deleteTable(id: $id)
  }
`;

export const UPDATE_PARTNER = gql`
  mutation UpdatePartner(
    $webpage: String
    $fb_page: String
    $instagram: String
    $about: String
    $short_desc: String
  ) {
    updatePartner(
      webpage: $webpage
      fb_page: $fb_page
      instagram: $instagram
      about: $about
      short_desc: $short_desc
    ) {
      id
      logo
      about
      short_desc
      fb_page
      instagram
      webpage
      url_name
    }
  }
`;

export const PARTNER_LOGO_UPLOAD = gql`
  mutation PartnerLogoUpload($file: Upload!) {
    partnerLogoUpload(file: $file) {
      id
      logo
    }
  }
`;

export const TICKET_LOGO_UPLOAD = gql`
  mutation TicketLogoUpload($file: Upload!) {
    ticketLogoUpload(file: $file) {
      url
    }
  }
`;
